import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import styled from 'styled-components'

import CenteredLoader from 'components/lib/CenteredLoader'
import ActionIcon from 'components/lib/DesignSystem/ActionIcon'
import Button from 'components/lib/DesignSystem/Button'
import { Close } from 'components/lib/DesignSystem/Icons'

const ESCAPE = 27

/**
 * Modal
 * Implementation inspired by Semantic UI
 */
class OldModal extends React.Component {
  static propTypes = {
    /** Shorthand for Modal.Actions. Typically an array of button shorthand. */
    // actions: customPropTypes.itemShorthand,

    /** Primary content. */
    children: PropTypes.node,

    /** Additional classes. */
    className: PropTypes.string,

    /** Don't show close icon X */
    closeIcon: PropTypes.bool,

    /** Simple text content for the Modal. */
    // content: customPropTypes.itemShorthand,

    /** Initial value of open. */
    defaultOpen: PropTypes.bool,

    /** A Modal can appear in a dimmer. */
    dimmer: PropTypes.oneOf([true, 'inverted', 'blurring']),

    /** Modal displayed above the content in bold. */
    // header: customPropTypes.itemShorthand,

    /** The node where the modal should mount. Defaults to document.body. */
    mountNode: PropTypes.any,

    /**
     * Called when a close event happens.
     *
     * @param {SyntheticEvent} event - React's original SyntheticEvent.
     * @param {object} data - All props.
     */
    onClose: PropTypes.func,

    /**
     * Called when an open event happens.
     *
     * @param {SyntheticEvent} event - React's original SyntheticEvent.
     * @param {object} data - All props.
     */
    onOpen: PropTypes.func,

    /** Controls whether or not the Modal is displayed. */
    open: PropTypes.bool,

    /** A modal can vary in size */
    size: PropTypes.oneOf(['mini', 'tiny', 'small', 'large', 'fullscreen']),

    /** Element to be rendered in-place where the portal is defined. */
    trigger: PropTypes.node,

    /** Confirm mode (yes, no) if function exist. */
    confirm: PropTypes.func,

    customConfirmYes: PropTypes.string,

    customConfirmNo: PropTypes.string,

    confirmValid: PropTypes.bool,

    loader: PropTypes.bool,

    open: PropTypes.bool,

    isShowConfirmBtn: PropTypes.bool,

    isShowCancelBtn: PropTypes.bool,
  }

  static defaultProps = {
    dimmer: true,
    size: 'small',
    closeIcon: true,
    confirmValid: true,
    open: true,
    isShowConfirmBtn: true,
    isShowCancelBtn: true,
  }

  // static Header = ModalHeader
  // static Content = ModalContent
  // static Actions = ModalActions

  state = {
    open: false,
    mountNode: this.props.mountNode || document.body,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.open !== nextProps.open) {
      if (nextProps.open) {
        this.onOpen()
      } else {
        this.onClose()
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
    if (this.state.open) document.querySelector('body').classList.remove('oh')
  }

  onOpen = () => {
    this.setState({ open: true })
    document.querySelector('body').classList.add('oh')
    document.addEventListener('keydown', this.handleKeyDown)
    if (typeof this.props.onOpen === 'function') {
      this.props.onOpen()
    }
  }

  onClose = () => {
    this.setState({ open: false })
    document.querySelector('body').classList.remove('oh')
    document.removeEventListener('keydown', this.handleKeyDown)
    if (typeof this.props.onClose === 'function') {
      this.props.onClose()
    }
  }

  handleKeyDown = (event) => {
    if (event.keyCode === ESCAPE) {
      this.onClose()
    }
  }

  handleConfirm = () => {
    if (this.props.open) {
      this.onClose()
    }
    this.props.confirm()
  }

  stopPropagation = (e) => e.stopPropagation()

  render() {
    const {
      className,
      confirm,
      noOutClickClose,
      closeIcon,
      children,
      customConfirmNo,
      customConfirmYes,
      confirmValid,
      customYesId,
      customNoId,
      loader,
      trigger,
      isShowConfirmBtn,
      isShowCancelBtn,
      modalStyle,
      id,
    } = this.props

    const ccn = classnames('is-modals', className)

    const isItConfirmModal = typeof confirm === 'function'

    return (
      <>
        {this.state.open &&
          ReactDOM.createPortal(
            <div
              id={id}
              ref={() => {
                window.closeModal = () => this.onClose()
              }}
              className={ccn}
              onClick={noOutClickClose ? null : this.onClose}
            >
              <div style={modalStyle} className="is-modal" onClick={this.stopPropagation}>
                {closeIcon && (
                  <ActionIcon
                    id="x-modal_close"
                    className="close-btn"
                    Icon={Close}
                    onClick={this.onClose}
                  />
                )}
                <div className="is-modal-content styled-scrollbar">
                  {React.cloneElement(children, {
                    modalCloseSelf: this.onClose,
                  })}
                </div>
                {isItConfirmModal ? (
                  <div className="tac mt">
                    {isShowCancelBtn && (
                      <Button
                        text={customConfirmNo || 'No'}
                        styleType="secondary"
                        onClick={this.onClose}
                        className="ml confirmModal-button-no"
                        id={customNoId}
                      />
                    )}
                    {isShowConfirmBtn && (
                      <Button
                        disabled={!confirmValid}
                        text={customConfirmYes || 'Yes'}
                        onClick={this.handleConfirm}
                        className="ml confirmModal-button-yes"
                        id={customYesId}
                      />
                    )}
                  </div>
                ) : null}
                {!!loader && <CenteredLoader overlap />}
              </div>
            </div>,
            this.state.mountNode
          )}
        {trigger &&
          React.cloneElement(trigger, {
            onClick: this.onOpen,
          })}
      </>
    )
  }
}

/**
 * @deprecated use Modal.js instead.
 */

const margin = (props) => {
  if (props.withMargin) {
    return `
      margin-top: 50px !important;
      margin-bottom: 50px !important;
      overflow-y: ${props.loader ? 'hidden' : 'auto'};
    `
  }
}

const size = (props) => {
  if (props.size === 'mini') {
    return `
      @media only screen and (min-width: 992px) {
        width: 340px;
      }
      @media only screen and (min-width: 768px) {
        width: 35.2%;
      }
    `
  } else if (props.size === 'tiny') {
    return `
      @media only screen and (min-width: 992px) {
        width: 510px;
      }
      @media only screen and (min-width: 768px) {
        width: 52.8%;
      }
    `
  } else if (props.size === 'large') {
    return `
      @media only screen and (min-width: 992px) {
        width: 1080px;
      }
      @media only screen and (min-width: 768px) {
        width: 88%;
      }
    `
  } else if (props.size === 'fullscreen') {
    return `
      @media only screen and (min-width: 992px) {
        width: 680px;
      }
      @media only screen and (min-width: 768px) {
        width: 70.4%;
      }
    `
  } else if (props.size === 'reclassify') {
    return `
      width: 540px;
      max-height: 320px !important;
    `
  } else if (props.size === 'fakelogin') {
    return `
      min-height: 570px !important;
      .screenshot {
        height: 462px;
        border-radius: 8px;
      }
    `
  } else if (props.size === 'whitelist') {
    return `
      @media only screen and (min-width: 992px) {
        width: 510px;
      }
      @media only screen and (min-width: 768px) {
        width: 52.8%;
        height: 75%;
      }
    `
  } else if (props.size === 'medium') {
    return `
      width: 710px;
      height: 650px;
    `
  }
  // size "small" by default
  return `
    @media only screen and (min-width: 992px) {
      width: 680px;
    }
    @media only screen and (min-width: 768px) {
      width: 70.4%;
    }
  `
}

export default styled(OldModal)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${(props) => props.theme.zIndexModal};
  display: flex;
  background-color: ${(props) => props.theme.modalBackgroundColor};

  .close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 1;
  }

  .is-modal {
    height: auto;
    margin: auto;
    padding: ${(props) => props.theme.baseMargin};
    border-radius: 6px;
    position: relative;
    background: white;
    box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.25);
    ${(props) => size(props)}
    ${(props) => margin(props)}

    @media only screen and (max-width: 750px) {
      width: 100%;
    }
  }

  .is-modal-content {
    height: 100%;
    overflow-y: auto;
  }
`
